<template>
  <customModal :containerxl="true" @closeModal="closeModal">
    <template #title>
      {{ $t("navigations.sdv rules list") }}
    </template>
    <template #body>
      <div class="sdv-rules-box">
        <!-- Loading spinner -->
        <div class="text-center" v-if="showLoading === true">
          <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
          <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
        </div>

        <!-- When not loading, show the search bar container and data -->
        <template v-else>
          <!-- Search bar container – always present when not loading -->
          <div class="mb-3">
            <!-- Search inputs + search button – shown only if there are rules -->
            <div
              class="d-flex flex-column flex-lg-row justify-content-lg-end my-2 my-lg-0"
              v-if="ruleList.length > 0"
            >
              <div class="col-lg-5">
                <div class="form-group mb-0">
                  <label class="mb-0">{{ $t("navigations.rule name") }}</label>
                  <input type="text" class="form-control my-lg-0" v-model="ruleNameSearch" />
                </div>
              </div>
              <div class="col-lg-5">
                <div class="form-group mb-0">
                  <label class="mb-0">{{ $t("navigations.rule type") }}</label>
                  <input type="text" class="form-control my-lg-0" v-model="ruleTypeSearch" />
                </div>
              </div>
              <span
                type="button"
                class="col-12 col-lg-2 save_btn w-100 align-self-end"
                @click.prevent="searchData()"
              >
                {{ $t("navigations.search") }}
              </span>
            </div>

            <!-- Create button – always visible when conditions are met (even if no data) -->
            <div
              class="d-flex justify-content-end mt-2"
              v-if="isPlanEditable && (!roleprivileges || roleprivileges.includes('SDV Rule Create'))"
            >
              <div class="position-relative align-self-center">
                <img
                  class="cursor-pointer"
                  width="20"
                  src="../../assets/img/create.png"
                  alt="Create Rule"
                  @click="assignRule"
                />
                <div class="tool-tip">{{ $t("navigations.create sdv rule") }}</div>
              </div>
            </div>
          </div>

          <!-- No data message -->
          <div class="text-center" v-if="ruleList.length === 0">
            {{ $t('navigations.no data available') }}
          </div>

          <!-- Table and pagination – shown only if there are rules -->
          <template v-if="ruleList.length > 0">
            <div class="table-responsive">
              <table class="table table-striped table-bordered dataTables">
                <thead>
                  <tr>
                      <th class="sort_block" @click="SortSelected('ruleNo')">
      <div class="d-flex flex-row justify-content-between">
        Rule No
        <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
      </div>
    </th>

                    <th class="sort_block" @click="SortSelected('ruleName')">
                      <div class="d-flex flex-row justify-content-between">
                        Rule Name
                        <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelected('ruleType')">
                      <div class="d-flex flex-row justify-content-between">
                        Rule Type
                        <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
                      </div>
                    </th>
                      <th class="sort_block" @click="SortSelected('formName')">
                      <div class="d-flex flex-row justify-content-between">
                        eCRF
                        <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelected('triggerType')">
                      <div class="d-flex flex-row justify-content-between">
                        Trigger Type
                        <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
                      </div>
                    </th>
                   <th>Site Code</th>
                    <th>Visit Name</th>
                    <th class="text-center">{{ $t("navigations.view") }}</th>
                    <th
                      class="text-center"
                      v-if="isPlanEditable && (!roleprivileges || roleprivileges.includes('SDV Rule Update'))"
                    >
                      Edit
                    </th>
                    <th
                      class="text-center"
                      v-if="isPlanEditable && (!roleprivileges || roleprivileges.includes('SDV Rule Delete'))"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="rule in ruleList" :key="rule.id">
                    <td>{{ rule.ruleNo }}</td>  
                    <td>{{ rule.ruleName }}</td>
                    <td>
                      <span class="badge" :class="ruleTypeBadgeClass(rule.ruleType)">
                        {{ rule.ruleType }}
                      </span>
                    </td>
                      <td>{{ rule.formName }}</td>
                    <td>{{ rule.triggerType }}</td>
                    <td>{{ getSiteCodes(rule.siteIds) }}</td>                    
                   <td>{{ getVisitNames(rule.visitIds) }}</td>
                    <td class="text-center">
                      <i class="fa fa-eye edit-delete" @click.prevent="viewRule(rule)"></i>
                    </td>
                    <td
                      class="text-center"
                      v-if="isPlanEditable && (!roleprivileges || roleprivileges.includes('SDV Rule Update'))"
                    >
                      <i class="fa fa-edit edit-delete" @click="editRule(rule)"></i>
                    </td>
                    <td
                      class="text-center"
                      v-if="isPlanEditable && (!roleprivileges || roleprivileges.includes('SDV Rule Delete'))"
                    >
                      <i class="fa fa-trash edit-delete ml-2" @click.prevent="deleteRule(rule)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="ruleList.length > 0">
                <VPagination
                  v-model="currentPage"
                  :pages="totalItems"
                  :range-size="1"
                  active-color="#ededed"
                  @update:modelValue="loadPage"
                />
              </div>
            </div>
          </template>
        </template>
      </div>

      <!-- Nested modal for Create/Edit/View -->
      <ManageSDVRule
        v-if="showCreateRuleModal"
        :editingId="editingRuleId"
        :planId="planId"
        :planVersion="planVersion"
        :viewMode="viewMode"
        @closeModal="showCreateRuleModal = false"
        @saved="refreshRuleList"
      />
    </template>
  </customModal>
</template>
<script src="./ManageSDVRuleList.js"></script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";

.wrap-table-cell {
  min-width: 70ch;
  text-wrap-mode: wrap;
}
input:disabled {
  cursor: not-allowed;
  opacity: 1;
}
.previousbtn,
.nextbtn {
  margin: 0;
  border-radius: 0px;
  border: 0.5px solid #eeeeee;
}
.page-links {
  border-radius: 0px;
}
.form-select {
  border-radius: 0 !important;
}
.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}
.position-relative img {
  width: 20px;
}
.cursor-pointer {
  cursor: pointer;
}
.position-relative {
  position: relative;
}
.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15;
  top: -20px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  transition: visibility 30ms ease-in;
}

/* Sort indicators (visual only) */
.sort_block {
  cursor: default;
  user-select: none;
}
.sort_block .d-flex {
  align-items: center;
}
.sort_block span i {
  margin-left: 4px;
  color: #ccc;
}

/* Existing modal styles (unchanged) */
.modal__container22 {
  width: 33%;
  max-width: 30%;
  position: fixed;
  height: 20% !important;
  margin-top: -550px !important;
  margin-left: 409px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}
.modal__container23 {
  width: 66%;
  max-width: 62%;
  position: fixed;
  height: -14% !important;
  margin-top: -683px !important;
  margin-left: 140px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}
.scrollable3 {
  overflow-y: scroll;
  height: 250px;
}
.audit__details__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}
.audit__details__modal__container {
  width: min(90%, 365px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
.audit__details__modal__title,
.audit__history__modal__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}
.heightBig {
  overflow-y: scroll;
  height: 250px;
}
.audit__history__modal__contents {
  overflow-y: scroll;
  height: 404px;
}
.audit__history__modal__wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 4000;
}
.audit__history__modal__container {
  width: min(45%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
.sdv-rules-box {
  background: #ffffff;
  border: 1px solid #e7eaec;
  border-radius: 2px;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.08);
  padding: 10px;
}
</style>